import React, {useState, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp} from 'react-icons/md';
import styled from 'styled-components';
import {useWindowSize} from 'react-use';
import CatalogAlbumDetailHeader from './CatalogAlbumDetailHeader';
import CatalogTracks from './CatalogTracks';
import BackBtn from '../../components/BackBtn';

const StyledSection = styled.section`
position: relative;
`;

const StyledArrows = styled.div` 
    cursor: pointer;
    border-bottom: 1px solid #10DB92;
    width: 110px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
	position: absolute;
    top: 4px;
    right: 0;

	@media (max-width: 768px) {
		top: -14px;
	}
`;

const CatalogAlbumDetail = ({onBack}) => {
	const {height: windowHeight} = useWindowSize();
	const {albumInfo} = useSelector((state) => state.catalog);
	const [open, setOpen] = useState(true);
	const heightAdjustment = useMemo(() => {
		if (windowHeight < 720) {
			return +300; 
		} else if (windowHeight < 900) {
			return +200;
		} else if (windowHeight < 1080) {
			return +100;
		} else if (windowHeight <= 1440) {
			return -400;
		} 
	}, [windowHeight]);

	const baseHeight = windowHeight - (open ? 220 : 380);
	
	const tracksHeight = baseHeight + heightAdjustment;
	return (
		<>
			<div className="d-flex align-items-center justify-content-between">
				<div className={`${open ? 'mb-4' : ''}`}><BackBtn onClick={onBack}/></div>
				<StyledArrows onClick={() => setOpen((prev) => !prev)}>
					{
						open
							? <span>Свернуть</span>
							: <span>Развернуть</span>
					}
					{
						open
							? <MdOutlineKeyboardArrowUp size={24}/>
							: <MdOutlineKeyboardArrowDown size={24}/>
					}
				</StyledArrows>
			</div>
			<StyledSection className="card__detailed-content" height={windowHeight - 300}>

				<CatalogAlbumDetailHeader albumInfo={albumInfo} open={open}/>
				<CatalogTracks height={tracksHeight}/>
			</StyledSection>
		</>
	);
};

export default CatalogAlbumDetail;
